// @flow

import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';

import {
  useNavState,
  useNavDispatch,
  NavContextActions,
  useModalState,
  useModalDispatch,
  ModalContextActions,
  usePageState,
} from 'contexts';
import { Color, flex, hoverChild, Transition } from 'styles';
import { LIGHT_DARK, VIDEO_PLAYER } from 'Constants';

const Wrapper = styled.div`
  height: 48px;
  width: 48px;
  ${flex()};
  transform: translateX(6px);
  pointer-events: auto;

  > div {
    position: relative;
    width: 15px;
    height: 12px;
    ${({ isDarkModal, theme, atTop, showingMobileNav }) =>
      isDarkModal || (theme === LIGHT_DARK.DARK && atTop && !showingMobileNav)
        ? css`
            ${hoverChild('div', 'background', Color.WHITE, Color.BLURPLE_LIGHT)};
          `
        : css`
            ${hoverChild('div', 'background', Color.BLACK, Color.PURPLE_FIGURE)};
          `};
    transition: transform ${Transition.DEFAULT_MOBILE};
    transform: translateY(${({ showingMobileNav }) => (showingMobileNav ? '3px' : 0)});

    > div {
      position: absolute;
      left: 0;
      height: 2px;
      border-radius: 100px;
      &:nth-of-type(1) {
        top: 0;
        width: 100%;
        transition: transform ${Transition.DEFAULT_MOBILE};
        transform-origin: 25% 0 0;
        transform: rotate(${({ showingMobileNav }) => (showingMobileNav ? '45deg' : 0)});
      }

      &:nth-of-type(2) {
        top: 5px;
        width: 100%;
        transition: transform ${Transition.DEFAULT_MOBILE};
        transform-origin: 25% 100% 0;
        transform: rotate(${({ showingMobileNav }) => (showingMobileNav ? '-45deg' : 0)});
      }

      &:nth-of-type(3) {
        bottom: 0;
        width: 50%;
        transition: transform ${Transition.DEFAULT_MOBILE};
        transform-origin: 50% 50% 0;
        transform: scale(${({ showingMobileNav }) => (showingMobileNav ? 0 : 1)});
      }
    }
  }
`;

const MenuButton = () => {
  const {
    headerConfig: { theme },
  } = usePageState();
  const { showingMobileNav, atTop } = useNavState();
  const { isOpen, id } = useModalState();
  const modalDispatch = useModalDispatch();
  const dispatch = useNavDispatch();
  const onClick = useCallback(() => {
    if (!isOpen) dispatch({ type: NavContextActions.TOGGLE_MOBILE_NAV });
    else modalDispatch({ type: ModalContextActions.CLOSE });
  }, [dispatch, isOpen, modalDispatch]);
  const isDarkModal = false;
  return useMemo(
    () => (
      <Wrapper isDarkModal={isDarkModal} theme={theme} atTop={atTop} onClick={onClick} showingMobileNav={showingMobileNav || isOpen}>
        <div>
          <div />
          <div />
          <div />
        </div>
      </Wrapper>
    ),
    [showingMobileNav, onClick, isOpen, theme, atTop, isDarkModal]
  );
};

export default MenuButton;
